import always from "./always";

const stubUndefined = always(void 0); // eslint-disable-line no-void

export default stubUndefined;
